import { cn } from '@/lib/utils';
import { Badge } from '@/components/ui/badge';

type GradeType = 'working_towards' | 'expected' | 'greater_depth';

interface GradeBadgeProps {
  grade: GradeType;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const gradeConfig: Record<GradeType, { label: string; className: string }> = {
  working_towards: {
    label: 'Working Towards',
    className: 'bg-grade-working-towards text-warning-foreground border-grade-working-towards',
  },
  expected: {
    label: 'Expected',
    className: 'bg-grade-expected text-success-foreground border-grade-expected',
  },
  greater_depth: {
    label: 'Greater Depth',
    className: 'bg-grade-greater-depth text-info-foreground border-grade-greater-depth',
  },
};

const sizeClasses = {
  sm: 'text-xs px-2 py-0.5',
  md: 'text-sm px-2.5 py-1',
  lg: 'text-base px-3 py-1.5 font-semibold',
};

export default function GradeBadge({ grade, size = 'md', className }: GradeBadgeProps) {
  const config = gradeConfig[grade];

  return (
    <Badge
      variant="outline"
      className={cn(
        'border-2 font-medium',
        config.className,
        sizeClasses[size],
        className
      )}
    >
      {config.label}
    </Badge>
  );
}
